//-------------------------------------------------------------------------------------------------- Imports
import { CSSProperties } from "react";
import { StyleSheet } from "../../../StyleSheet";
import { Col, Row } from "antd";
import { ResponseSuscriptorDataHiredService } from "../../../types/common";
import _ from "lodash";

//-------------------------------------------------------------------------------------------------- Interfaces
interface AssociatedContractCardProps {
    title: string;
    services: ResponseSuscriptorDataHiredService[] | undefined;
};

//-------------------------------------------------------------------------------------------------- Components
const AssociatedContractCard = (props: AssociatedContractCardProps) => {
    const { title, services } = props;
    const headerBGColor: CSSProperties = (title === "SERVICIOS") ? (styles.headerBackground1) : (
        (title === "PREMIER") ? (styles.headerBackground2) : (styles.headerBackground3)
    );

    const renderInfo = () => (
        (services && !_.isEmpty(services)) ? (
            services.map((obj, index: number) => (
                <Row
                    key={index}
                    style={{
                        ...styles.tableRow,
                        ...(index !== services.length - 1) ? styles.tableRowBorder : undefined
                    }}
                >
                    {(title === "SERVICIOS" || title === "PREMIER") ? (
                        <>
                            <Col span={14}>
                                <p style={styles.titleServText}>{obj.desServicio}</p>
                                <p style={styles.descServText}>{obj.tipocontrato === "P" ? "Principal" : "Adicional"}</p>
                            </Col>
                            <Col span={10}>
                                <p style={styles.textGeneral}>{obj.estadoFormateado}</p>
                                <p style={styles.textGeneral}>Último Pago</p>
                                <p style={styles.textGeneral}>{obj.fechaUltimoPago}</p>
                            </Col>
                        </>
                    ) : (
                        <Col span={24}>
                            <p style={styles.titleServText}>{obj.desTipoEquipo}</p>
                            <p style={styles.descServText}>{`Serie: ${obj.serie}`}</p>
                            <p style={styles.descServText}>{`Modelo: ${obj.modelo}`}</p>
                        </Col>
                    )}
                </Row>
            ))
        ) : (
            <p>{"Sin Información"}</p>
        )
    );

    return (
        <div style={styles.mainContainer}>
            <Row style={{ ...styles.headerStyle, ...headerBGColor }}>
                <Col>
                    <p style={{ margin: 0 }}><b>{title}</b></p>
                </Col>
            </Row>
            {renderInfo()}
        </div>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        display: "flex",
        margin: 10,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: "20px",
        backgroundColor: "transparent",
        boxShadow: "0px 0px 8px #00000029",
    },
    headerStyle: {
        color: "#ffffff",
        width: "100%",
        padding: 10,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "20px 20px 0px 0px",
    },
    headerBackground1: {
        backgroundColor: "#0080ff",
    },
    headerBackground2: {
        backgroundColor: "#0055ba",
    },
    headerBackground3: {
        backgroundColor: "#08427c",
    },
    // Table
    tableRow: {
        marginTop: 20,
        width: "90%",
        padding: "5px 15px 10px 15px",
    },
    tableRowBorder: {
        borderBottom: "1px solid #000000",
    },
    titleServText: {
        margin: 0,
        fontSize: 13,
        fontWeight: 600,
    },
    descServText: {
        margin: 0,
        fontSize: 13,
    },
    textGeneral: {
        margin: 0,
        fontSize: 12,
        color: "#757982",
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default AssociatedContractCard;
